import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { Container, Typography, Box, Paper } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material'; // Import from @mui/icons-material
import {  ApproveOrDeniedEPOViaEmail } from '../../services/expense-purchase-order';
import useQuery from '../../custom-hooks/useQuery';
import Approveimg from '../../assets/images/Approvd.png' 
import Deniedimg from '../../assets/images/Denied.png' 

export const ThankyouPageForEpo = () => {
  const [message, setMessage] = useState('');
  const [success,setsucess] = useState(false);
  let { epoId } = useParams();
  let query = useQuery();
  var viewValue = query.get("case");
  let userId, isApprove;
  if (viewValue) {
    userId = viewValue.split('?').find(part => part.startsWith('userid=')).split('=')[1];
    isApprove = viewValue.split('?').find(part => part.startsWith('isApprove=')).split('=')[1];
    viewValue = viewValue.split('?')[0];
  }

  const SubmitApproval = async () => {
    try {
      const response = await ApproveOrDeniedEPOViaEmail(epoId,isApprove,userId);
      if (response.status === 200) {
        if(isApprove === "true"){
        setMessage("Epo Approval  successfully");
        }else{
          setMessage("Epo Denied  successfully");
        }
        setsucess(true);
      } else {
        setMessage("Epo is not submitted");
      }
    } catch (error) {
      setMessage("An error occurred while submitting FTO");
      setsucess(false);
    }
  }

  useEffect(() => {
    if (userId && isApprove) {
      SubmitApproval();
    }
  }, []); 
  
  return (
    <>
      {success && (
        isApprove === 'true' ? (
          <img src={Approveimg} alt="ss_white_img" height="100%" width="100%" />
        ) : (
          <img src={Deniedimg} alt="ss_white_img" height="100%" width="100%" />
        )
      )}
    </>
  );
  
}
